import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unknown: {
		id: 'contextual-summary.common.user-avatar.unknown',
		defaultMessage: 'Unknown',
		description: 'Label for an avatar when the user is unknown',
	},
});
